// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"sq-z","imageAndVideoCount":"tq-z","imageAndVideoContainer":"uq-z","viewAllReviews":"vq-z"};